import { Icon } from 'components/ui'
import { socials } from 'constants/link'

import { Wrap, Container, Copyright, Socials, SocialsText, SocialItem, Version } from './Style'

const Footer = () => {
  return (
    <Wrap>
      <Container>
        <Copyright>©&nbsp;{new Date().getFullYear()}&nbsp;_mad-assembly</Copyright>

        <Socials>
          <SocialsText>_socials:</SocialsText>
          <SocialItem href={socials.TWITTER} ariaLabel='Twitter link'>
            <Icon name='twitter' size='large' />
          </SocialItem>
          <SocialItem href={socials.DISCORD} ariaLabel='Discord link'>
            <Icon name='discord' size='large' />
          </SocialItem>
        </Socials>
        {/* TODO: add version programming into future */}
        <Version>_version: 0.0.1</Version>
      </Container>
    </Wrap>
  )
}

export { Footer }
